import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";
import { HistoricoOperacaoCreditoLivre, OperacaoCreditoLivre } from "src/app/model/operacao-credito-livre.model";
import { LiberacaoOperacaoGarantida } from "src/app/model/operacao-garantida.model";

@Component({
    selector: 'aba-liberacoes',
    templateUrl: 'aba-liberacoes.component.html',
    standalone: false
})
export class AbaLiberacoesComponent implements OnChanges{
    @Input()
    public operacao: OperacaoCreditoLivre;
    @Input()
    public modoEdicao: Boolean;
    @Input()
    public emInclusao: Boolean;
    @Input()
    public modoRetificacao: Boolean;

    public liberacoes:LiberacaoOperacaoGarantida[];

    ngOnChanges(changes: SimpleChanges): void {
        this.liberacoes = this.operacao.detalhe.liberacoes;
    }
}
